import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

export const DragIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox='0 0 20 20'>
        <path d="M7 9H9V11H7V9ZM7 5H9V7H7V5ZM7 13H9V15H7V13ZM11 9H13V11H11V9ZM11 5H13V7H11V5ZM11 13H13V15H11V13Z" fill="#9CA5B6"/>
    </SvgIcon>
);
